import { Link } from "react-router-dom";
import React from "react";
import Slider from "react-slick";


export default function PopularAirlines() {
  const HotelSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: true
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: true
        }
      }
    ]
  };



  return (
<>


  <section id="PopularAirlines" className="section-with-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
<h2><strong>Our Best Airline Deals</strong> Worldwide</h2>
          <p>Check Out Best Cheap Flights Prices Airline Deals</p>
        </div>

        <div className="row" data-aos="fade-up" data-aos-delay="100">
              <Slider {...HotelSlider}>
          <div className="col-lg-4 col-md-6">
            <div className="hotel lat_bor">
<center> <span className="bg-british_airways"></span></center>
<p>Special Discount on British Airways</p>
<h3><a href="#">Best Deals on Flight Tickets</a></h3>
<hr className="hor_lDes" />
<h3 className="book_now"><span>Book Now</span></h3>
<p>Special Fares to Various Sector</p>
  <div className="pricesandlists">
<p className="exclusive_save">
<span className="expir_des">Expires in</span>
<span className="expir_des2"><span className="rates_fnt">365</span> Days</span></p>
<p className="rates_design2" id="air10"><span className="rates_design">Save</span><i className="rates_us">$</i>200*</p>
</div>
 </div>
  </div>

          <div className="col-lg-4 col-md-6">
            <div className="hotel lat_bor">
<center> <span className="bg-Delta"></span></center>
<p>Special Discount on Delta</p>
<h3><a href="#">Best Deals on Flight Tickets</a></h3>
<hr className="hor_lDes" />
<h3 className="book_now"><span>Book Now</span></h3>
<p>Special Fares to Various Sector</p>
  <div className="pricesandlists">
<p className="exclusive_save">
<span className="expir_des">Expires in</span>
<span className="expir_des2"><span className="rates_fnt">270</span> Days</span></p>
<p className="rates_design2" id="air10"><span className="rates_design">Save</span><i className="rates_us">$</i>125*</p>
</div>
 </div>
  </div>
            <div className="col-lg-4 col-md-6">
            <div className="hotel lat_bor">
<center> <span className="bg-emirates_airlines"></span></center>
<p>Discount on Emirates Aairlines</p>
<h3><a href="#">Best Deals on Flight Tickets</a></h3>
<hr className="hor_lDes" />
<h3 className="book_now"><span>Book Now</span></h3>
<p>Special Fares to Various Sector</p>
  <div className="pricesandlists">
<p className="exclusive_save">
<span className="expir_des">Expires in</span>
<span className="expir_des2"><span className="rates_fnt">190</span> Days</span></p>
<p className="rates_design2" id="air10"><span className="rates_design">Save</span><i className="rates_us">$</i>105*</p>
</div>
 </div>
  </div>
          
        <div className="col-lg-4 col-md-6">
            <div className="hotel lat_bor">
<center> <span className="bg-american_airlines"></span></center>
<p> Discount on American Airlines</p>
<h3><a href="#">Best Deals on Flight Tickets</a></h3>
<hr className="hor_lDes" />
<h3 className="book_now"><span>Book Now</span></h3>
<p>Special Fares to Various Sector</p>
  <div className="pricesandlists">
<p className="exclusive_save">
<span className="expir_des">Expires in</span>
<span className="expir_des2"><span className="rates_fnt">210</span> Days</span></p>
<p className="rates_design2" id="air10"><span className="rates_design">Save</span><i className="rates_us">$</i>85*</p>
</div>
 </div>
  </div>
   <div className="col-lg-4 col-md-6">
            <div className="hotel lat_bor">
<center> <span className="bg-united_airlines"></span></center>
<p> Discount on United Airlines</p>
<h3><a href="#">Best Deals on Flight Tickets</a></h3>
<hr className="hor_lDes" />
<h3 className="book_now"><span>Book Now</span></h3>
<p>Special Fares to Various Sector</p>
  <div className="pricesandlists">
<p className="exclusive_save">
<span className="expir_des">Expires in</span>
<span className="expir_des2"><span className="rates_fnt">365</span> Days</span></p>
<p className="rates_design2" id="air10"><span className="rates_design">Save</span><i className="rates_us">$</i>250*</p>
</div>
 </div>
  </div>
   <div className="col-lg-4 col-md-6">
            <div className="hotel lat_bor">
<center> <span className="bg-singapore_airlines"></span></center>
<p> Discount on Singapore Airlines</p>
<h3><a href="#">Best Deals on Flight Tickets</a></h3>
<hr className="hor_lDes" />
<h3 className="book_now"><span>Book Now</span></h3>
<p>Special Fares to Various Sector</p>
  <div className="pricesandlists">
<p className="exclusive_save">
<span className="expir_des">Expires in</span>
<span className="expir_des2"><span className="rates_fnt">250</span> Days</span></p>
<p className="rates_design2" id="air10"><span className="rates_design">Save</span><i className="rates_us">$</i>220*</p>
</div>
 </div>
  </div>
     <div className="col-lg-4 col-md-6">
            <div className="hotel lat_bor">
<center> <span className="bg-hawaiian_airlines"></span></center>
<p> Discount on Hawaiian Airlines</p>
<h3><a href="#">Best Deals on Flight Tickets</a></h3>
<hr className="hor_lDes" />
<h3 className="book_now"><span>Book Now</span></h3>
<p>Special Fares to Various Sector</p>
  <div className="pricesandlists">
<p className="exclusive_save">
<span className="expir_des">Expires in</span>
<span className="expir_des2"><span className="rates_fnt">300</span> Days</span></p>
<p className="rates_design2" id="air10"><span className="rates_design">Save</span><i className="rates_us">$</i>100*</p>
</div>
 </div>
  </div>
     <div className="col-lg-4 col-md-6">
            <div className="hotel lat_bor">
<center> <span className="bg-turkish_airlines"></span></center>
<p> Discount on Turkish Airlines</p>
<h3><a href="#">Best Deals on Flight Tickets</a></h3>
<hr className="hor_lDes" />
<h3 className="book_now"><span>Book Now</span></h3>
<p>Special Fares to Various Sector</p>
  <div className="pricesandlists">
<p className="exclusive_save">
<span className="expir_des">Expires in</span>
<span className="expir_des2"><span className="rates_fnt">180</span> Days</span></p>
<p className="rates_design2" id="air10"><span className="rates_design">Save</span><i className="rates_us">$</i>250*</p>
</div>
 </div>
  </div>

             </Slider>                     

        </div>
      </div>

    </section>


    </>
  );
}
